/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
import InstanceType from './InstanceType';
import GenerateSQL from './GenerateSQL';
import QuerySubjectUsage from './QuerySubjectUsage';
import SelectListControlType from './SelectListControlType';
import SourceCategoryType from './SourceCategoryType';
import QsClassifierType from './QsClassifierType';
import SetOperation from './SetOperation';
import SetOperationDuplicates from './SetOperationDuplicates';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper, updatePropertyOverride
//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/GenerateSQL (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/QuerySubjectUsage (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SelectListControlType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SourceCategoryType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/QsClassifierType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SetOperation (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SetOperationDuplicates (runtime) // new

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="originalRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="instanceType" type="{}instanceType" minOccurs="0"/&gt; &lt;element name="generateSQL" type="{}generateSQL" minOccurs="0"/&gt; &lt;element name="useInJoinPath" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="numberOfRows" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="rowCount" type="{http://www.w3.org/2001/XMLSchema}long" minOccurs="0"/&gt; &lt;element name="querySubjectUsage" type="{}querySubjectUsage" minOccurs="0"/&gt; &lt;element name="useLocalCache" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="selectListControl" type="{}selectListControlType" minOccurs="0"/&gt; &lt;element name="columnDependency" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="keyRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element ref="{}queryItem" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}filter" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;choice&gt; &lt;element name="sqlQuery" type="{}sqlQueryType" minOccurs="0"/&gt; &lt;element name="queryOperation" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="queryRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element name="setOperation" type="{}setOperation"/&gt; &lt;element name="duplicates" type="{}setOperationDuplicates"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="joinOperation" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="queryRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element ref="{}relationship" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/choice&gt; &lt;element name="sourceCategory" type="{}sourceCategoryType" minOccurs="0"/&gt; &lt;element name="sortList" type="{}sortListType" minOccurs="0"/&gt; &lt;element name="item" type="{}itemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="classifier" type="{}qsClassifierType" minOccurs="0"/&gt; &lt;element name="dataCacheExpiry" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="itemNormalization" type="{}itemNormalizationType" minOccurs="0"/&gt; &lt;element name="shortcutTargetQuerySubjectRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element ref="{}securityFilter" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class QuerySubject extends ObjectType{

	ref = null;

	originalRef = null;

	instanceType = null;

	generateSQL = null;

	useInJoinPath = null;

	numberOfRows = null;

	rowCount = null;

	querySubjectUsage = null;

	useLocalCache = null;

	selectListControl = null;

	columnDependency = null;

	queryItem = null;

	filter = null;

	sqlQuery = null;

	queryOperation = null;

	joinOperation = null;

	sourceCategory = null;

	sortList = null;

	item = null;

	classifier = null;

	dataCacheExpiry = null;

	itemNormalization = null;

	shortcutTargetQuerySubjectRef = null;

	securityFilter = null;



	/**
	 * Gets the value of the ref property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the ref property. <p> For example, to add a new item, do as follows: <pre> getRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getRef() {
		if (!this.ref) {
			this.ref = [];
		}
		return this.ref;
	}

	/**
	 * Gets the value of the originalRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the originalRef property. <p> For example, to add a new item, do as follows: <pre> getOriginalRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getOriginalRef() {
		if (!this.originalRef) {
			this.originalRef = [];
		}
		return this.originalRef;
	}

	/**
	 * Gets the value of the instanceType property.
	 * @return {InstanceType} possible object is {@link InstanceType}
	 */
	getInstanceType() {
		return this.instanceType;
	}

	/**
	 * Sets the value of the instanceType property.
	 * @param {InstanceType} value allowed object is {@link InstanceType}
	 */
	setInstanceType(value) {
		var oldValue = this.instanceType;
		this.instanceType = value;
		this._setAndNotify(58, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the generateSQL property.
	 * @return {GenerateSQL} possible object is {@link GenerateSQL}
	 */
	getGenerateSQL() {
		return this.generateSQL;
	}

	/**
	 * Sets the value of the generateSQL property.
	 * @param {GenerateSQL} value allowed object is {@link GenerateSQL}
	 */
	setGenerateSQL(value) {
		var oldValue = this.generateSQL;
		this.generateSQL = value;
		this._setAndNotify(45, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the useInJoinPath property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isUseInJoinPath() {
		return this.useInJoinPath;
	}

	/**
	 * Sets the value of the useInJoinPath property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setUseInJoinPath(value) {
		var oldValue = this.useInJoinPath;
		this.useInJoinPath = value;
		this._setAndNotify(51, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the numberOfRows property.
	 * @return {String} possible object is {@link String}
	 */
	getNumberOfRows() {
		return this.numberOfRows;
	}

	/**
	 * Sets the value of the numberOfRows property.
	 * @param {String} value allowed object is {@link String}
	 */
	setNumberOfRows(value) {
		var oldValue = this.numberOfRows;
		this.numberOfRows = value;
		this._setAndNotify(61, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the rowCount property.
	 * @return {Number} possible object is {@link Long}
	 */
	getRowCount() {
		return this.rowCount;
	}

	/**
	 * Sets the value of the rowCount property.
	 * @param {Number} value allowed object is {@link Long}
	 */
	setRowCount(value) {
		var oldValue = this.rowCount;
		this.rowCount = value;
		this._setAndNotify(53, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the querySubjectUsage property.
	 * @return {QuerySubjectUsage} possible object is {@link QuerySubjectUsage}
	 */
	getQuerySubjectUsage() {
		return this.querySubjectUsage;
	}

	/**
	 * Sets the value of the querySubjectUsage property.
	 * @param {QuerySubjectUsage} value allowed object is {@link QuerySubjectUsage}
	 */
	setQuerySubjectUsage(value) {
		var oldValue = this.querySubjectUsage;
		this.querySubjectUsage = value;
		this._setAndNotify(49, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the useLocalCache property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isUseLocalCache() {
		return this.useLocalCache;
	}

	/**
	 * Sets the value of the useLocalCache property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setUseLocalCache(value) {
		var oldValue = this.useLocalCache;
		this.useLocalCache = value;
		this._setAndNotify(55, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the selectListControl property.
	 * @return {SelectListControlType} possible object is {@link SelectListControlType}
	 */
	getSelectListControl() {
		return this.selectListControl;
	}

	/**
	 * Sets the value of the selectListControl property.
	 * @param {SelectListControlType} value allowed object is {@link SelectListControlType}
	 */
	setSelectListControl(value) {
		var oldValue = this.selectListControl;
		this.selectListControl = value;
		this._setAndNotify(50, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the columnDependency property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the columnDependency property. <p> For example, to add a new item, do as follows: <pre> getColumnDependency().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link QuerySubject.ColumnDependency}
	 */
	getColumnDependency() {
		if (!this.columnDependency) {
			this.columnDependency = [];
		}
		return this.columnDependency;
	}

	/**
	 * A query item from a query subject. Obsolete location (after 3.2). The new location is querySubject/item[n]/queryItem Gets the value of the queryItem property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the queryItem property. <p> For example, to add a new item, do as follows: <pre> getQueryItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link QueryItem}
	 */
	getQueryItem() {
		if (!this.queryItem) {
			this.queryItem = [];
		}
		return this.queryItem;
	}

	/**
	 * Gets the value of the filter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the filter property. <p> For example, to add a new item, do as follows: <pre> getFilter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Filter}
	 */
	getFilter() {
		if (!this.filter) {
			this.filter = [];
		}
		return this.filter;
	}

	/**
	 * Gets the value of the sqlQuery property.
	 * @return {SqlQueryType} possible object is {@link SqlQueryType}
	 */
	getSqlQuery() {
		return this.sqlQuery;
	}

	/**
	 * Sets the value of the sqlQuery property.
	 * @param {SqlQueryType} value allowed object is {@link SqlQueryType}
	 */
	setSqlQuery(value) {
		var oldValue = this.sqlQuery;
		this.sqlQuery = value;
		this._setAndNotify(56, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the queryOperation property.
	 * @return {QueryOperation} possible object is {@link QuerySubject.QueryOperation}
	 */
	getQueryOperation() {
		return this.queryOperation;
	}

	/**
	 * Sets the value of the queryOperation property.
	 * @param {QueryOperation} value allowed object is {@link QuerySubject.QueryOperation}
	 */
	setQueryOperation(value) {
		var oldValue = this.queryOperation;
		this.queryOperation = value;
		this._setAndNotify(47, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the joinOperation property.
	 * @return {JoinOperation} possible object is {@link QuerySubject.JoinOperation}
	 */
	getJoinOperation() {
		return this.joinOperation;
	}

	/**
	 * Sets the value of the joinOperation property.
	 * @param {JoinOperation} value allowed object is {@link QuerySubject.JoinOperation}
	 */
	setJoinOperation(value) {
		var oldValue = this.joinOperation;
		this.joinOperation = value;
		this._setAndNotify(59, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the sourceCategory property.
	 * @return {SourceCategoryType} possible object is {@link SourceCategoryType}
	 */
	getSourceCategory() {
		return this.sourceCategory;
	}

	/**
	 * Sets the value of the sourceCategory property.
	 * @param {SourceCategoryType} value allowed object is {@link SourceCategoryType}
	 */
	setSourceCategory(value) {
		var oldValue = this.sourceCategory;
		this.sourceCategory = value;
		this._setAndNotify(46, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the sortList property.
	 * @return {SortListType} possible object is {@link SortListType}
	 */
	getSortList() {
		return this.sortList;
	}

	/**
	 * Sets the value of the sortList property.
	 * @param {SortListType} value allowed object is {@link SortListType}
	 */
	setSortList(value) {
		var oldValue = this.sortList;
		this.sortList = value;
		this._setAndNotify(18, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the item property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the item property. <p> For example, to add a new item, do as follows: <pre> getItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemType}
	 */
	getItem() {
		if (!this.item) {
			this.item = [];
		}
		return this.item;
	}

	/**
	 * Gets the value of the classifier property.
	 * @return {QsClassifierType} possible object is {@link QsClassifierType}
	 */
	getClassifier() {
		return this.classifier;
	}

	/**
	 * Sets the value of the classifier property.
	 * @param {QsClassifierType} value allowed object is {@link QsClassifierType}
	 */
	setClassifier(value) {
		var oldValue = this.classifier;
		this.classifier = value;
		this._setAndNotify(52, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the dataCacheExpiry property.
	 * @return {String} possible object is {@link String}
	 */
	getDataCacheExpiry() {
		return this.dataCacheExpiry;
	}

	/**
	 * Sets the value of the dataCacheExpiry property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDataCacheExpiry(value) {
		var oldValue = this.dataCacheExpiry;
		this.dataCacheExpiry = value;
		this._setAndNotify(62, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the itemNormalization property.
	 * @return {ItemNormalizationType} possible object is {@link ItemNormalizationType}
	 */
	getItemNormalization() {
		return this.itemNormalization;
	}

	/**
	 * Sets the value of the itemNormalization property.
	 * @param {ItemNormalizationType} value allowed object is {@link ItemNormalizationType}
	 */
	setItemNormalization(value) {
		var oldValue = this.itemNormalization;
		this.itemNormalization = value;
		this._setAndNotify(54, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the shortcutTargetQuerySubjectRef property.
	 * @return {String} possible object is {@link String}
	 */
	getShortcutTargetQuerySubjectRef() {
		return this.shortcutTargetQuerySubjectRef;
	}

	/**
	 * Sets the value of the shortcutTargetQuerySubjectRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setShortcutTargetQuerySubjectRef(value) {
		var oldValue = this.shortcutTargetQuerySubjectRef;
		this.shortcutTargetQuerySubjectRef = value;
		this._setAndNotify(48, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the securityFilter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the securityFilter property. <p> For example, to add a new item, do as follows: <pre> getSecurityFilter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link SecurityFilter}
	 */
	getSecurityFilter() {
		if (!this.securityFilter) {
			this.securityFilter = [];
		}
		return this.securityFilter;
	}

	/**
	 * Gets the value of the <code>ref</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetRef() {
		return this.ref;
	}

	/**
	 * Gets the value of the <code>originalRef</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetOriginalRef() {
		return this.originalRef;
	}

	/**
	 * Gets the value of the <code>columnDependency</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ColumnDependency</code> elements, or <code>null</code> if not set
	 */
	basicGetColumnDependency() {
		return this.columnDependency;
	}

	/**
	 * Gets the value of the <code>queryItem</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>QueryItem</code> elements, or <code>null</code> if not set
	 */
	basicGetQueryItem() {
		return this.queryItem;
	}

	/**
	 * Gets the value of the <code>filter</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Filter</code> elements, or <code>null</code> if not set
	 */
	basicGetFilter() {
		return this.filter;
	}

	/**
	 * Gets the value of the <code>item</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ItemType</code> elements, or <code>null</code> if not set
	 */
	basicGetItem() {
		return this.item;
	}

	/**
	 * Gets the value of the <code>securityFilter</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>SecurityFilter</code> elements, or <code>null</code> if not set
	 */
	basicGetSecurityFilter() {
		return this.securityFilter;
	}

	/**
	 * Creates a new instance of <code>QuerySubject</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> QuerySubject</code> object from.
	 * @return {QuerySubject} an object of type <code>QuerySubject</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQuerySubject();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addRefAt(position, item) {
		this._addAtAndNotify(this.getRef(), position, item, 36, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addRef(item) {
		this.addRefAt(this.getRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeRefAt(position) {
		this._removeAtAndNotify(this.getRef(), position, 36, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeRef(item) {
		var i = this.getRef().indexOf(item);
		if (i >= 0) {
			this.removeRefAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addOriginalRefAt(position, item) {
		this._addAtAndNotify(this.getOriginalRef(), position, item, 60, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addOriginalRef(item) {
		this.addOriginalRefAt(this.getOriginalRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeOriginalRefAt(position) {
		this._removeAtAndNotify(this.getOriginalRef(), position, 60, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeOriginalRef(item) {
		var i = this.getOriginalRef().indexOf(item);
		if (i >= 0) {
			this.removeOriginalRefAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addColumnDependencyAt(position, item) {
		this._addAtAndNotify(this.getColumnDependency(), position, item, 57, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addColumnDependency(item) {
		this.addColumnDependencyAt(this.getColumnDependency().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeColumnDependencyAt(position) {
		this._removeAtAndNotify(this.getColumnDependency(), position, 57, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeColumnDependency(item) {
		var i = this.getColumnDependency().indexOf(item);
		if (i >= 0) {
			this.removeColumnDependencyAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addQueryItemAt(position, item) {
		this._addAtAndNotify(this.getQueryItem(), position, item, 28, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addQueryItem(item) {
		this.addQueryItemAt(this.getQueryItem().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeQueryItemAt(position) {
		this._removeAtAndNotify(this.getQueryItem(), position, 28, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeQueryItem(item) {
		var i = this.getQueryItem().indexOf(item);
		if (i >= 0) {
			this.removeQueryItemAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addFilterAt(position, item) {
		var filterList = this.getFilter();
		for (var i = 0; (i < filterList.length); ++i) {
			var override = filterList[i];
			if ((override.getIdentifier() != null) && override.getIdentifier() == item.getIdentifier()) {
				return;
			}
		}
		this._addAtAndNotify(this.getFilter(), position, item, 24, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addFilter(item) {
		this.addFilterAt(this.getFilter().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeFilterAt(position) {
		this._removeAtAndNotify(this.getFilter(), position, 24, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeFilter(item) {
		var i = this.getFilter().indexOf(item);
		if (i >= 0) {
			this.removeFilterAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addItemAt(position, item) {
		this._addAtAndNotify(this.getItem(), position, item, 3, true, false);
		var qi = item.getQueryItem();
		if (qi) {
			MoserObject.updatePropertyOverride(qi, this, 28, true);
		}
		var hierarchy = item.getItemHierarchy();
		if (hierarchy) {
			MoserObject.updatePropertyOverride(hierarchy, this, 27, true);
		}
		var namedSet = item.getNamedSet();
		if (namedSet) {
			MoserObject.updatePropertyOverride(namedSet, this, 26, true);
		}
		var filter = item.getFilter();
		if (filter) {
			MoserObject.updatePropertyOverride(filter, this, 24, true);
		}
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addItem(item) {
		this.addItemAt(this.getItem().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeItemAt(position) {
		this._removeAtAndNotify(this.getItem(), position, 3, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeItem(item) {
		var i = this.getItem().indexOf(item);
		if (i >= 0) {
			this.removeItemAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addSecurityFilterAt(position, item) {
		this._addAtAndNotify(this.getSecurityFilter(), position, item, 44, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addSecurityFilter(item) {
		this.addSecurityFilterAt(this.getSecurityFilter().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeSecurityFilterAt(position) {
		this._removeAtAndNotify(this.getSecurityFilter(), position, 44, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeSecurityFilter(item) {
		var i = this.getSecurityFilter().indexOf(item);
		if (i >= 0) {
			this.removeSecurityFilterAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "QuerySubject";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(true, false, false, 36, "ref", null));
		featureList.push(this.createFeature(true, false, false, 60, "originalRef", null));
		featureList.push(this.createFeature(false, true, false, 58, "instanceType", InstanceType));
		featureList.push(this.createFeature(false, true, false, 45, "generateSQL", GenerateSQL));
		featureList.push(this.createFeature(false, false, false, 51, "useInJoinPath", null));
		featureList.push(this.createFeature(false, false, false, 61, "numberOfRows", null));
		featureList.push(this.createFeature(false, false, false, 53, "rowCount", null));
		featureList.push(this.createFeature(false, true, false, 49, "querySubjectUsage", QuerySubjectUsage));
		featureList.push(this.createFeature(false, false, false, 55, "useLocalCache", null));
		featureList.push(this.createFeature(false, true, false, 50, "selectListControl", SelectListControlType));
		var clazz;
		if (factory) {
			clazz = factory.createQuerySubjectColumnDependency().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 57, "columnDependency", clazz));
		if (factory) {
			clazz = factory.createQueryItem().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 28, "queryItem", clazz));
		if (factory) {
			clazz = factory.createFilter().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 24, "filter", clazz));
		if (factory) {
			clazz = factory.createSqlQueryType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 56, "sqlQuery", clazz));
		if (factory) {
			clazz = factory.createQuerySubjectQueryOperation().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 47, "queryOperation", clazz));
		if (factory) {
			clazz = factory.createQuerySubjectJoinOperation().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 59, "joinOperation", clazz));
		featureList.push(this.createFeature(false, true, false, 46, "sourceCategory", SourceCategoryType));
		if (factory) {
			clazz = factory.createSortListType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 18, "sortList", clazz));
		if (factory) {
			clazz = factory.createItemType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 3, "item", clazz));
		featureList.push(this.createFeature(false, true, false, 52, "classifier", QsClassifierType));
		featureList.push(this.createFeature(false, false, false, 62, "dataCacheExpiry", null));
		if (factory) {
			clazz = factory.createItemNormalizationType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 54, "itemNormalization", clazz));
		featureList.push(this.createFeature(false, false, false, 48, "shortcutTargetQuerySubjectRef", null));
		if (factory) {
			clazz = factory.createSecurityFilter().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 44, "securityFilter", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 45:
			this.setGenerateSQL((value));
			break;
		case 46:
			this.setSourceCategory((value));
			break;
		case 47:
			this.setQueryOperation((value));
			break;
		case 48:
			this.setShortcutTargetQuerySubjectRef((value));
			break;
		case 49:
			this.setQuerySubjectUsage((value));
			break;
		case 50:
			this.setSelectListControl((value));
			break;
		case 51:
			this.setUseInJoinPath((value));
			break;
		case 18:
			this.setSortList((value));
			break;
		case 52:
			this.setClassifier((value));
			break;
		case 53:
			this.setRowCount((value));
			break;
		case 54:
			this.setItemNormalization((value));
			break;
		case 55:
			this.setUseLocalCache((value));
			break;
		case 56:
			this.setSqlQuery((value));
			break;
		case 58:
			this.setInstanceType((value));
			break;
		case 59:
			this.setJoinOperation((value));
			break;
		case 61:
			this.setNumberOfRows((value));
			break;
		case 62:
			this.setDataCacheExpiry((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 44:
			this.securityFilter = (value);
			break;
		case 36:
			this.ref = (value);
			break;
		case 3:
			this.item = (value);
			break;
		case 57:
			this.columnDependency = (value);
			break;
		case 24:
			this.filter = (value);
			break;
		case 28:
			this.queryItem = (value);
			break;
		case 60:
			this.originalRef = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 44:
			return this.getSecurityFilter();
		case 45:
			return this.getGenerateSQL();
		case 46:
			return this.getSourceCategory();
		case 47:
			return this.getQueryOperation();
		case 48:
			return this.getShortcutTargetQuerySubjectRef();
		case 36:
			return this.getRef();
		case 49:
			return this.getQuerySubjectUsage();
		case 50:
			return this.getSelectListControl();
		case 51:
			return this.isUseInJoinPath();
		case 18:
			return this.getSortList();
		case 52:
			return this.getClassifier();
		case 53:
			return this.getRowCount();
		case 54:
			return this.getItemNormalization();
		case 3:
			return this.getItem();
		case 55:
			return this.isUseLocalCache();
		case 56:
			return this.getSqlQuery();
		case 57:
			return this.getColumnDependency();
		case 58:
			return this.getInstanceType();
		case 59:
			return this.getJoinOperation();
		case 24:
			return this.getFilter();
		case 28:
			return this.getQueryItem();
		case 60:
			return this.getOriginalRef();
		case 61:
			return this.getNumberOfRows();
		case 62:
			return this.getDataCacheExpiry();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 44:
			return this.basicGetSecurityFilter();
		case 45:
			return this.getGenerateSQL();
		case 46:
			return this.getSourceCategory();
		case 47:
			return this.getQueryOperation();
		case 48:
			return this.getShortcutTargetQuerySubjectRef();
		case 36:
			return this.basicGetRef();
		case 49:
			return this.getQuerySubjectUsage();
		case 50:
			return this.getSelectListControl();
		case 51:
			return this.isUseInJoinPath();
		case 18:
			return this.getSortList();
		case 52:
			return this.getClassifier();
		case 53:
			return this.getRowCount();
		case 54:
			return this.getItemNormalization();
		case 3:
			return this.basicGetItem();
		case 55:
			return this.isUseLocalCache();
		case 56:
			return this.getSqlQuery();
		case 57:
			return this.basicGetColumnDependency();
		case 58:
			return this.getInstanceType();
		case 59:
			return this.getJoinOperation();
		case 24:
			return this.basicGetFilter();
		case 28:
			return this.basicGetQueryItem();
		case 60:
			return this.basicGetOriginalRef();
		case 61:
			return this.getNumberOfRows();
		case 62:
			return this.getDataCacheExpiry();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 44:
			this.addSecurityFilterAt(position, (value));
			break;
		case 36:
			this.addRefAt(position, (value));
			break;
		case 3:
			this.addItemAt(position, (value));
			break;
		case 57:
			this.addColumnDependencyAt(position, (value));
			break;
		case 24:
			this.addFilterAt(position, (value));
			break;
		case 28:
			this.addQueryItemAt(position, (value));
			break;
		case 60:
			this.addOriginalRefAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 44:
			this.addSecurityFilter((value));
			break;
		case 36:
			this.addRef((value));
			break;
		case 3:
			this.addItem((value));
			break;
		case 57:
			this.addColumnDependency((value));
			break;
		case 24:
			this.addFilter((value));
			break;
		case 28:
			this.addQueryItem((value));
			break;
		case 60:
			this.addOriginalRef((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 44:
			this.removeSecurityFilterAt(position);
			break;
		case 36:
			this.removeRefAt(position);
			break;
		case 3:
			this.removeItemAt(position);
			break;
		case 57:
			this.removeColumnDependencyAt(position);
			break;
		case 24:
			this.removeFilterAt(position);
			break;
		case 28:
			this.removeQueryItemAt(position);
			break;
		case 60:
			this.removeOriginalRefAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 44:
			this.removeSecurityFilter((item));
			break;
		case 36:
			this.removeRef((item));
			break;
		case 3:
			this.removeItem((item));
			break;
		case 57:
			this.removeColumnDependency((item));
			break;
		case 24:
			this.removeFilter((item));
			break;
		case 28:
			this.removeQueryItem((item));
			break;
		case 60:
			this.removeOriginalRef((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="keyRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
QuerySubject.ColumnDependency = class extends MoserObject{

	ref = null;

	keyRef = null;

	_referencedObject = null;



	/**
	 * Gets the value of the ref property.
	 * @return {String} possible object is {@link String}
	 */
	getRef() {
		return this.ref;
	}

	/**
	 * Sets the value of the ref property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRef(value) {
		var oldValue = this.ref;
		this.ref = value;
		this._setAndNotify(36, oldValue, value, false, false);
		this._referencedObject = null;
	}

	/**
	 * Gets the value of the keyRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the keyRef property. <p> For example, to add a new item, do as follows: <pre> getKeyRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getKeyRef() {
		if (!this.keyRef) {
			this.keyRef = [];
		}
		return this.keyRef;
	}

	/**
	 * Gets the value of the <code>keyRef</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetKeyRef() {
		return this.keyRef;
	}

	/**
	 * Creates a new instance of <code>ColumnDependency</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ColumnDependency</code> object from.
	 * @return {ColumnDependency} an object of type <code>ColumnDependency</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQuerySubjectColumnDependency();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addKeyRefAt(position, item) {
		this._addAtAndNotify(this.getKeyRef(), position, item, 37, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addKeyRef(item) {
		this.addKeyRefAt(this.getKeyRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeKeyRefAt(position) {
		this._removeAtAndNotify(this.getKeyRef(), position, 37, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeKeyRef(item) {
		var i = this.getKeyRef().indexOf(item);
		if (i >= 0) {
			this.removeKeyRefAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ColumnDependency";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 36, "ref", null));
		featureList.push(this.createFeature(true, false, false, 37, "keyRef", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 36:
			this.setRef((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 37:
			this.keyRef = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 36:
			return this.getRef();
		case 37:
			return this.getKeyRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 36:
			return this.getRef();
		case 37:
			return this.basicGetKeyRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 37:
			this.addKeyRefAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 37:
			this.addKeyRef((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 37:
			this.removeKeyRefAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 37:
			this.removeKeyRef((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	 */
	setReferencedObject(referencedObject) {
		this._referencedObject = referencedObject;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code>
	 */
	getReferencedObject() {
		return this._referencedObject;
	}

	clone() {
		var cloned = (super.clone());
		cloned.setReferencedObject(this._referencedObject);
		return cloned;
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="queryRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element ref="{}relationship" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
QuerySubject.JoinOperation = class extends MoserObject{

	queryRef = null;

	relationship = null;



	/**
	 * Gets the value of the queryRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the queryRef property. <p> For example, to add a new item, do as follows: <pre> getQueryRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getQueryRef() {
		if (!this.queryRef) {
			this.queryRef = [];
		}
		return this.queryRef;
	}

	/**
	 * A query that represents the join of two query subjects or tables.Gets the value of the relationship property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the relationship property. <p> For example, to add a new item, do as follows: <pre> getRelationship().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Relationship}
	 */
	getRelationship() {
		if (!this.relationship) {
			this.relationship = [];
		}
		return this.relationship;
	}

	/**
	 * Gets the value of the <code>queryRef</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetQueryRef() {
		return this.queryRef;
	}

	/**
	 * Gets the value of the <code>relationship</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Relationship</code> elements, or <code>null</code> if not set
	 */
	basicGetRelationship() {
		return this.relationship;
	}

	/**
	 * Creates a new instance of <code>JoinOperation</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> JoinOperation</code> object from.
	 * @return {JoinOperation} an object of type <code>JoinOperation</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQuerySubjectJoinOperation();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addQueryRefAt(position, item) {
		this._addAtAndNotify(this.getQueryRef(), position, item, 186, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addQueryRef(item) {
		this.addQueryRefAt(this.getQueryRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeQueryRefAt(position) {
		this._removeAtAndNotify(this.getQueryRef(), position, 186, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeQueryRef(item) {
		var i = this.getQueryRef().indexOf(item);
		if (i >= 0) {
			this.removeQueryRefAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addRelationshipAt(position, item) {
		this._addAtAndNotify(this.getRelationship(), position, item, 133, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addRelationship(item) {
		this.addRelationshipAt(this.getRelationship().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeRelationshipAt(position) {
		this._removeAtAndNotify(this.getRelationship(), position, 133, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeRelationship(item) {
		var i = this.getRelationship().indexOf(item);
		if (i >= 0) {
			this.removeRelationshipAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "JoinOperation";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(true, false, false, 186, "queryRef", null));
		var clazz;
		if (factory) {
			clazz = factory.createRelationship().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 133, "relationship", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 133:
			this.relationship = (value);
			break;
		case 186:
			this.queryRef = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 133:
			return this.getRelationship();
		case 186:
			return this.getQueryRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 133:
			return this.basicGetRelationship();
		case 186:
			return this.basicGetQueryRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 133:
			this.addRelationshipAt(position, (value));
			break;
		case 186:
			this.addQueryRefAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 133:
			this.addRelationship((value));
			break;
		case 186:
			this.addQueryRef((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 133:
			this.removeRelationshipAt(position);
			break;
		case 186:
			this.removeQueryRefAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 133:
			this.removeRelationship((item));
			break;
		case 186:
			this.removeQueryRef((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="queryRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element name="setOperation" type="{}setOperation"/&gt; &lt;element name="duplicates" type="{}setOperationDuplicates"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
QuerySubject.QueryOperation = class extends MoserObject{

	queryRef = null;

	setOperation = null;

	duplicates = null;



	/**
	 * Gets the value of the queryRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the queryRef property. <p> For example, to add a new item, do as follows: <pre> getQueryRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getQueryRef() {
		if (!this.queryRef) {
			this.queryRef = [];
		}
		return this.queryRef;
	}

	/**
	 * Gets the value of the setOperation property.
	 * @return {SetOperation} possible object is {@link SetOperation}
	 */
	getSetOperation() {
		return this.setOperation;
	}

	/**
	 * Sets the value of the setOperation property.
	 * @param {SetOperation} value allowed object is {@link SetOperation}
	 */
	setSetOperation(value) {
		var oldValue = this.setOperation;
		this.setOperation = value;
		this._setAndNotify(184, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the duplicates property.
	 * @return {SetOperationDuplicates} possible object is {@link SetOperationDuplicates}
	 */
	getDuplicates() {
		return this.duplicates;
	}

	/**
	 * Sets the value of the duplicates property.
	 * @param {SetOperationDuplicates} value allowed object is {@link SetOperationDuplicates}
	 */
	setDuplicates(value) {
		var oldValue = this.duplicates;
		this.duplicates = value;
		this._setAndNotify(185, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the <code>queryRef</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetQueryRef() {
		return this.queryRef;
	}

	/**
	 * Creates a new instance of <code>QueryOperation</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> QueryOperation</code> object from.
	 * @return {QueryOperation} an object of type <code>QueryOperation</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQuerySubjectQueryOperation();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addQueryRefAt(position, item) {
		this._addAtAndNotify(this.getQueryRef(), position, item, 186, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addQueryRef(item) {
		this.addQueryRefAt(this.getQueryRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeQueryRefAt(position) {
		this._removeAtAndNotify(this.getQueryRef(), position, 186, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeQueryRef(item) {
		var i = this.getQueryRef().indexOf(item);
		if (i >= 0) {
			this.removeQueryRefAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "QueryOperation";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(true, false, false, 186, "queryRef", null));
		featureList.push(this.createFeature(false, true, false, 184, "setOperation", SetOperation));
		featureList.push(this.createFeature(false, true, false, 185, "duplicates", SetOperationDuplicates));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 184:
			this.setSetOperation((value));
			break;
		case 185:
			this.setDuplicates((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 186:
			this.queryRef = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 184:
			return this.getSetOperation();
		case 185:
			return this.getDuplicates();
		case 186:
			return this.getQueryRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 184:
			return this.getSetOperation();
		case 185:
			return this.getDuplicates();
		case 186:
			return this.basicGetQueryRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 186:
			this.addQueryRefAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 186:
			this.addQueryRef((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 186:
			this.removeQueryRefAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 186:
			this.removeQueryRef((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/QuerySubject.js